module.exports = __webpack_public_path__ + "img/cateicon4_a.3779ce26.svg";